import NOMAD_API_CONSTANTS from '@/constants/nomad-api';
import { JobCategoryPage } from '@/features/job-category-page/types';
import { isNurse } from '@/utils/discipline-utils';

export const jobCategoryDisciplineByDisciplineType = (
  disciplineType?: JobCategoryPage['disciplineType']
): string | undefined => {
  return isNurse(disciplineType) ? NOMAD_API_CONSTANTS.NURSE_API_ID : undefined;
};
